module.exports = __webpack_public_path__ + "images/default_avatars/jokul-43396cbf2354464a1796d4819aa045b1.jpg";